/**
 * 个人中心静态路由数据
 * */

export default {
  path: '/personalCenter',
  name: 'personalCenter',
  component: () => import('@/views/index/components/personalCenter/index.vue'),
  meta: {
    unrequireLogin: false
  },
  redirect: {
    name: 'personDefault'
  },
  children: [
    // 应用列表
    {
      path: '/personalCenter/default',
      name: 'personDefault',
      component: () => import('@/views/index/components/personalCenter/default.vue'),
    },
    // 应用管理
    {
      path: '/personalCenter/appManage',
      name: 'personAppManage',
      component: () => import('@/views/index/components/personalCenter/appManage/appManage.vue'),
      children: [
        {
          path: '/personalCenter/appManage/devConfig',
          name: 'appManegeAppConfig',
          component: () => import('@/views/index/components/personalCenter/appManage/appManageConfig.vue'),
        },
        {
          path: '/personalCenter/appManage/appDetail',
          name: 'appManegeAppDetail',
          component: () => import('@/views/index/components/personalCenter/appManage/appManageDetail.vue'),
        },
        {
          path: '/personalCenter/appManage/interfaceSub',
          name: 'appManegeAppInterface',
          component: () => import('@/views/index/components/personalCenter/appManage/appManageInterface.vue'),
        },
        {
          path: '/personalCenter/appManage/dataInterfaceSub',
          name: 'appManegeAppDataInterface',
          component: () => import('@/views/index/components/personalCenter/appManage/appManageDataInterface.vue'),
        },
        {
          path: '/personalCenter/appManage/openSearch',
          name: 'appManegeAppOpenSearch',
          component: () => import('@/views/index/components/personalCenter/appManage/appManageSearch.vue'),
        },
        {
          path: '/personalCenter/appManage/scoringApplication',
          name: 'appManegeAppScoringApplication',
          component: () => import('@/views/index/components/personalCenter/appManage/appScoringApplication.vue'),
        }
      ]
    },
    // 应用发布
    {
      path: '/personalCenter/appPublish',
      name: 'personAppPublish',
      component: () => import('@/views/index/components/personalCenter/appPublish.vue'),
    },
    // 接口订阅
    {
      path: '/personalCenter/interfaceSub',
      name: 'personInterfaceSub',
      component: () => import('@/views/index/components/personalCenter/interfaceSub.vue'),
    },
    // 组件管理
    {
      path: '/personalCenter/compManage',
      name: 'personCompManage',
      component: () => import('@/views/index/components/personalCenter/compManage/compManage.vue'),
      redirect: {
        name: 'compManageList'
      },
      children: [
        // 组件管理列表
        {
          path: '/personalCenter/compManage/list',
          name: 'compManageList',
          component: () => import('@/views/index/components/personalCenter/compManage/compManageList.vue'),
        },
        // 组件详情
        {
          path: '/personalCenter/compManage/detail',
          name: 'compManageDetail',
          component: () => import('@/views/index/components/personalCenter/compManage/compManageDetail.vue'),
        },
      ]
    },
  ]
}
